// removed by extract-text-webpack-plugin
module.exports = {"globalFooter":"antd-pro-globalFooter","links":"antd-pro-links","copyright":"antd-pro-copyright"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/GlobalFooter/index.less
// module id = 373
// module chunks = 0 1